import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../api/api';
import { MenuItem } from '../../types';

interface MenuState {
  items: MenuItem[];
  loading: boolean;
}

export const fetchMenu = createAsyncThunk('menu/fetchAll', async () => {
  const res = await api.get<MenuItem[]>('/menu');
  return res.data;
});

export const createMenuItem = createAsyncThunk('menu/create', async (data: any) => {
  const res = await api.post<MenuItem>('/menu', data);
  return res.data;
});

export const updateMenuItem = createAsyncThunk(
  'menu/update',
  async ({ id, data }: { id: number; data: any }) => {
    const res = await api.put<MenuItem>(`/menu/${id}`, data);
    return res.data;
  }
);

const menuSlice = createSlice({
  name: 'menu',
  initialState: { items: [], loading: false } as MenuState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenu.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenu.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchMenu.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createMenuItem.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })
      .addCase(updateMenuItem.fulfilled, (state, action) => {
        const idx = state.items.findIndex((i) => i.id === action.payload.id);
        if (idx !== -1) state.items[idx] = action.payload;
      });
  },
});

export default menuSlice.reducer;
